var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block cursor-pointer align-middle",class:_vm.getClass(),on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}})}
var staticRenderFns = []

export { render, staticRenderFns }